import { EHeaderStateActionType } from './types';
import { IHeaderData } from '../../headerData';
import { getHeaderData } from '../../services/getHeaderData';
import { getNotificationsCount } from '../../services/getNotificationsCount';
import { getUnreadMessages } from '../../services/getUnreadMessages';
import { TThunkAction } from '../../types/redux';
import { getLocationIdFromCookie } from '../../utils/cookie';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { updateMessagesCount } from '../messages';
import { updateNotificationsCount } from '../notifications/updateCount';

export const updateHeaderData = actionGenerator<EHeaderStateActionType.Update, IHeaderData>(
  EHeaderStateActionType.Update,
);

export const updateState =
  (authenticated: boolean = true): TThunkAction<Promise<void>> =>
  async (dispatch, getState, context) => {
    try {
      const [headerData, notificationsCount, messagesCount] = await Promise.all([
        getHeaderData(context, { subdomain: context.custom.subdomain, locationId: getLocationIdFromCookie(context) }),
        getNotificationsCount(context),
        getUnreadMessages(context, authenticated),
      ]);

      dispatch(updateHeaderData(headerData));
      dispatch(updateNotificationsCount(notificationsCount));
      dispatch(updateMessagesCount(messagesCount));
    } catch (e) {
      context.telemetry.increment('actions.refresh-state.fail');
      context.logger.warning(e, {
        domain: 'actions.headerState.refreshState',
      });
    }
  };
